// import { useModules } from 'hooks';
import { v4 as uuidv4 } from 'uuid';

const CheckPermistions = (modules, id) => {
  // const modules = useModules();
  const module = modules.find((module) => module.moduleID === id);
  // return true;

  if (module) {
    return true;
  } else {
    return false;
  }
};

export default CheckPermistions;


function getDeviceId() {
  let deviceId = localStorage.getItem('device_id');
  if (!deviceId) {
    deviceId = uuidv4();
    localStorage.setItem('device_id', deviceId);
  }
  return deviceId;
}


export const detectBrowserAndDevice = () => {
  const UserAgent = navigator.userAgent;
  const device = {
    iPad: /iPad/.test(UserAgent),
    iPhone: /iPhone/.test(UserAgent),
    Android: /Android/.test(UserAgent),
    Windows: /Windows/.test(UserAgent),
    macOS: /Macintosh/.test(UserAgent),
    Linux: /Linux/.test(UserAgent),
    BlackBerry: /BlackBerry/.test(UserAgent),
    iPod: /iPod/.test(UserAgent),
    Samsung: /Samsung/.test(UserAgent),
    Nokia: /Nokia/.test(UserAgent),
    Sony: /Sony/.test(UserAgent),
    HTC: /HTC/.test(UserAgent),
    LG: /LG/.test(UserAgent),
    Motorola: /Motorola/.test(UserAgent),
    Nexus: /Nexus/.test(UserAgent),
    Kindle: /Kindle/.test(UserAgent),
    FirePhone: /Fire Phone/.test(UserAgent)
  };

  let browserName;

  // Checking for browser
  if (/Firefox\//.test(UserAgent)) {
    browserName = "Mozilla Firefox";
  } else if (/Edg\//.test(UserAgent)) {
    browserName = "Microsoft Edge";
  } else if (/Chrome\//.test(UserAgent)) {
    browserName = "Google Chrome";
  } else if (/Safari\//.test(UserAgent)) {
    browserName = "Apple Safari";
  } else if (/OPR\//.test(UserAgent)) {
    browserName = "Opera";
  } else if (/Trident\//.test(UserAgent)) {
    browserName = "Microsoft Internet Explorer";
  } else if (/UCBrowser\//.test(UserAgent)) {
    browserName = "UC Browser";
  } else if (/SamsungBrowser\//.test(UserAgent)) {
    browserName = "Samsung Internet";
  } else if (/MQQBrowser\//.test(UserAgent)) {
    browserName = "QQ Browser";
  } else if (/WeChat\//.test(UserAgent)) {
    browserName = "WeChat Browser";
  } else if (/Yandex\//.test(UserAgent)) {
    browserName = "Yandex Browser";
  } else if (/AppleWebKit\//.test(UserAgent)) {
    browserName = "WebKit-based Browser (unknown)";
  } else {
    browserName = "Unknown Browser";
  }
  var navigator_info = window.navigator;
  var screen_info = window.screen;
  var uid = navigator_info.mimeTypes.length;
  uid += navigator_info.userAgent.replace(/\D+/g, '');
  uid += navigator_info.plugins.length;
  uid += screen_info.height || '';
  uid += screen_info.width || '';
  uid += screen_info.pixelDepth || '';

  const device_id = getDeviceId()
  // Constructing the result object
  const result = {
    browser: browserName,
    device: Object.keys(device).find(dev => device[dev]) || "Unknown Device",
    deviceId: uid + "/" + device_id
  };

  return result;
}


export function parseDate(dateStr) {
  // Support both DD-MM-YYYY and D-M-YYYY
  const [day, month, year] = dateStr?.split("-").map(Number);
  if (!day || !month || !year) return null;

  // Construct as UTC to avoid timezone issues
  const date = new Date(Date.UTC(year, month - 1, day));
  return isNaN(date.getTime()) ? null : date;
}